const DistributorsCol = [
    {
      id: 'id',
      numeric: false,
      disablePadding: true,
      label: 'ID',
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      required: true,
      label: 'Distributor Name',
    },
    {
      id: 'contact_number',
      numeric: true,
      disablePadding: false,
      required: true,
      label: 'Phone',
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: true,
      label: 'Email',
    },
    {
      id: 'full_name',
      numeric: false,
      disablePadding: true,
      required: true,
      label: 'Full Name',
    },
    {
      id: 'state_name',
      numeric: false,
      disablePadding: false,
      required: true,
      label: 'States',
    },
    {
      id: 'state',
      numeric: false,
      disablePadding: false,
      required: true,
      label: 'State',
    },
    {
      id: 'city',
      numeric: false,
      disablePadding: false,
      required: true,
      label: 'City',
    },
    {
      id: 'landing_cost',
      numeric: true,
      disablePadding: false,
      label: 'Discount (%)',
    },
    {
      id: 'gst_number',
      numeric: false,
      disablePadding: false,
      required: true,
      label: 'GST Number',
    },
    {
      id: 'password',
      numeric: false,
      disablePadding: false,
      label: 'Password',
    },
    // {
    //   id: 'total_points',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Total Points',
    // },
    // {
    //   id: 'avaiable_points',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Available Points',
    // },
    {
      id: 'pan_number',
      numeric: false,
      disablePadding: false,
      label: 'PAN Number',
    },
    // {
    //   id: 'account_number',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Account Number',
    // },
    {
      id: 'aadhar_number',
      numeric: false,
      disablePadding: false,
      label: 'Aadhar Number',
    },
    {
      id: 'address',
      numeric: false,
      disablePadding: false,
      label: 'Address',
    },
    // {
    //   id: 'ifsc_code',
    //   numeric: false,
    //   disablePadding: true,
    //   label: 'IFSC',
    // },
    {
      id: 'pin_code',
      numeric: false,
      disablePadding: false,
      label: 'Pin Code',
    },
    // {
    //   id: 'bank_name',
    //   numeric: false,
    //   disablePadding: false,
    //   label: 'Bank',
    // },
    {
      id: 'is_active',
      numeric: false,
      disablePadding: false,
      label: 'Is Active',
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: 'Actions',
    },
  ];
  
  export default DistributorsCol;
  